import React from 'react';
import { Building2, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#020B1A] border-t border-cyan-500/20 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Two-Column Office Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-8">
          
          {/* Left Column - Singapore Office */}
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Building2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-white mb-1">AXORA CLOUD PTE. LTD.</h3>
                <p className="text-sm text-gray-400">(UEN: 202626979D)</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Email:</p>
                <a 
                  href="mailto:finance@axoracloudservice.com" 
                  className="text-white hover:text-cyan-400 transition-colors duration-200"
                >
                  finance@axoracloudservice.com
                </a>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Address:</p>
                <p className="text-white leading-relaxed">
                  62 UBI ROAD 1, #08-06,<br />
                  OXLEY BIZHUB 2,<br />
                  SINGAPORE 408734
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Business Hours:</p>
                <p className="text-white">Mon – Fri: 9:00 AM – 6:00 PM</p>
              </div>
            </div>
          </div>
          
          {/* Right Column - Malaysia Office */}
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Building2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-white mb-1">AXORA CLOUD SERVICE SDN. BHD.</h3>
                <p className="text-sm text-gray-400">(Registration No.: 202601023185 (1685282V))</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Email:</p>
                <a 
                  href="mailto:finance@axoracloudservice.com" 
                  className="text-white hover:text-cyan-400 transition-colors duration-200"
                >
                  finance@axoracloudservice.com
                </a>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Address:</p>
                <p className="text-white leading-relaxed">
                  Level 20-02, Menara Hap Seng 2,<br />
                  No. 1 & 3, Jalan P. Ramlee,<br />
                  50250 Kuala Lumpur, Malaysia.
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-sm text-gray-400 mb-1">Business Hours:</p>
                <p className="text-white">Mon – Fri: 9:00 AM – 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright Notice */}
        <div className="border-t border-cyan-500/20 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 AXORA CLOUD. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
